export default "__VITE_ASSET__CD07FAbM__"